import { render, staticRenderFns } from "./DisbursesList.vue?vue&type=template&id=20845c09"
import script from "./DisbursesList.vue?vue&type=script&lang=js"
export * from "./DisbursesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports